import { render, staticRenderFns } from "./universityManagement.vue?vue&type=template&id=1715f732"
import script from "./universityManagement.vue?vue&type=script&lang=js"
export * from "./universityManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports